import { RunResponseType } from "../../storyV2/adapter/AdapterBase";
import { FuncResponseType } from "../../storyV2/function/FunctionBase";
export class AdapterResponseUtil {
    static responseTypeTransform(funcResType) {
        switch (funcResType) {
            case FuncResponseType.ASK_BRAIN:
                return RunResponseType.ASK_BRAIN;
            case FuncResponseType.IMAGE_TEXT:
                return RunResponseType.IMAGE;
            case FuncResponseType.STREAM_TEXT:
                return RunResponseType.STREAM;
            case FuncResponseType.AMAZON_SHOPPING:
                return RunResponseType.AMAZONSHOPPING;
            case FuncResponseType.CHAT_INTERFACE:
                return RunResponseType.CHAT_INTERFACE;
            case FuncResponseType.PROTEIN:
                return RunResponseType.PROTEIN;
            case FuncResponseType.TEXT:
                return RunResponseType.TEXT;
            case FuncResponseType.STRING_GROUP:
                return RunResponseType.STRING_GROUP;
            case FuncResponseType.STOCK:
            case FuncResponseType.STOCK_GROUP:
                return RunResponseType.STOCK;
            case FuncResponseType.JD_SHOPPING:
                return RunResponseType.JDSHOPPING;
            case FuncResponseType.YOUTUBE_VIDEOS:
                return RunResponseType.YOUTUBE_VIDEOS;
            case FuncResponseType.WEEE_GROCERIES:
                return RunResponseType.WEEEGRPCERIES;
            case FuncResponseType.WEEE_SHOPPING:
                return RunResponseType.WEEESHOPPING;
            case FuncResponseType.MAP:
                return RunResponseType.MAP;
            case FuncResponseType.IMAGE_GROUP:
                return RunResponseType.IMAGE_GROUP;
            case FuncResponseType.FOOD:
                return RunResponseType.FOOD;
            case FuncResponseType.MIDJOURNEY:
                return RunResponseType.MIDJOURNEY;
            case FuncResponseType.CUSTOM_API:
                return RunResponseType.CUSTOM_API;
            case FuncResponseType.INTERVIEW_BOT:
                return RunResponseType.INTERVIEW_BOT;
            case FuncResponseType.BLUEPRINT:
                return RunResponseType.BLUEPRINT;
        }
    }
}
